import { useDispatch } from 'react-redux';
import { useForm } from 'new/elements/Form/useForm';
import { useCallback, useEffect } from 'react';
import { loadDataCredentials, loadFullVendor, setError } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';

/**
 * Fetches data and manages state for the Connections page.
 * This hook fetches data related to credentials and vendors based on the selected connection.
 * @param selectedConnection string
 */
export default function useConnectionsPage(selectedConnection) {
  const dispatch = useAppDispatch();
  const { setValidation } = useForm();

  const validateSelectedConnection = useCallback(() => {
    if (!!selectedConnection) {
      return true;
    }
    dispatch(setError({ message: 'You need to select a connection type.' }));
    return false;
  }, [selectedConnection]);

  useEffect(() => {
    setValidation(validateSelectedConnection);
  }, [validateSelectedConnection]);

  useEffect(() => {
    dispatch(loadFullVendor(selectedConnection));
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  }, [selectedConnection]);
}
